import { Either, left, right } from "fp-ts/lib/Either";
import QAAgentEntity from "../../../../domain/entities/qa_agent.entity";
import ErrorEntity from "../../../../domain/entities/error.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const updateAgentApiImpl = async (formData: FormData): Promise<Either<ErrorEntity, QAAgentEntity>> => {
  try {
    const id = formData.get("id") as string;
    const relativeUrl = `/agent/${id}`;

    const response = await di.get<HostApi>(HostApiName).put(relativeUrl, formData, {
      contentType: undefined, // importante: no lo pongas en multipart
    });

    const parsed = new QAAgentEntity({
      id: response.id,
      name: response.name,
      description: response.description,
      clientId: response.clientId,
      categories: response.categories ?? [],
      target: response.target,
      flexibility: response.flexibility,
      files: response.files,
      assistant_id: response.assistant_id ?? '',
      vector_store_id: response.vector_store_id ?? '',
      is_assistant: response.is_assistant?? false,
    });

    return right(parsed);
  } catch (error) {
    return left(ErrorEntity.fromError(error));
  }
};


export default updateAgentApiImpl;